import React from 'react'

import './Footer.scss'

import Social from './Social/Social'
import Policy from './Policy/Policy'

import Sound from './Assets/sound'
import NoSound from './Assets/noSound'

const spanStyle = {
    color: 'white',
    fontSize: '1.5rem',
    lineHeight: 'normal',
}

function Footer({activeSound, toggleSound, openFooter, toggleFooter}) {

    return (
        <footer className='banzai_footer'>
            <div className='banzai_footer__main'>
                <div className='banzai_footer__info'>
                    <Social />
                    <span style={spanStyle}>|</span>
                    <button onClick={toggleFooter} className='cervoSm white' >INFORMAZIONI LEGALI</button>
                </div>

                <button onClick={toggleSound} className='banzai_footer__sound'>
                    { activeSound ? <Sound /> : <NoSound /> }                    
                </button>
            </div>            
            <div className={`banzai_footer__policy ${openFooter ? 'footerVisible' : '' }`}>
                <Policy />
            </div>
        </footer>
    )
}

export default Footer